import { render, staticRenderFns } from "./DiscountFields.vue?vue&type=template&id=20aafe3f&scoped=true&"
import script from "./DiscountFields.vue?vue&type=script&lang=js&"
export * from "./DiscountFields.vue?vue&type=script&lang=js&"
import style0 from "./DiscountFields.vue?vue&type=style&index=0&id=20aafe3f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20aafe3f",
  null
  
)

export default component.exports